import dayjs from "dayjs";
import BKV from "../bkv/bkv";
import { crc16 } from "../bkv/parse";
import { arrayBufferToHex } from "../js/utils";


function padStart(v, l = 2, c = '0') {
    return v.toString().padStart(l, c)
}
function hexToArrayBuffer(hex) {
    if (typeof hex !== 'string') {
        return { code: -1, message: 'Expected input to be a string' }
    }

    if ((hex.length % 2) !== 0) {
        return { code: -2, message: 'Expected string to be an even number of characters' }
    }

    let array = new Uint8Array(hex.length / 2);

    for (let i = 0; i < hex.length; i += 2) {
        array[i / 2] = parseInt(hex.substring(i, i + 2), 16)
    }

    return { code: 0, data: array }
}
// BKV 解包
function runParser(hex) {
    let res = hexToArrayBuffer(hex);
    if (res.code !== 0) {
        return res
    }
    let buffer = res.data

    if (buffer.length < 4) {
        return { code: -3, message: 'Buffer too short' }
    }

    let backHeadIndex = buffer.findIndex((e) => e === 0x87); // 设备返回数据
    let sendHeadIndex = buffer.findIndex((e) => e === 0x84); // 主机写入数据
    if (backHeadIndex < 0 && sendHeadIndex < 0) {
        console.log('parser', 'head not exists');
    }

    let headIndex = backHeadIndex >= 0 ? backHeadIndex : sendHeadIndex

    let fb = buffer.slice(headIndex);
    if (fb.length < 4) {
        return { code: -4, message: 'frame length too short' }
    }

    let length = fb[1];
    if (fb.length < length + 4) {
        return { code: -5, message: 'frame length not match' }
    }

    let checksum = new DataView(fb.buffer).getUint16(2 + length, false)
    let calculatedChecksum = crc16(fb.slice(1, length + 2));
    if (checksum !== calculatedChecksum) {
        return { code: -6, message: 'checksum not match' }
    }

    let b = BKV.unpack(fb.slice(2, length + 2));
    if (b.code === 0) {
        return { code: 0, data: b.bkv, type: backHeadIndex >= 0 ? 'back' : 'send' }
    } else {
        return { code: -7, message: 'bkv parse fail' }
    }
}

const CONST = {
    // 帧类型
    FRAME_TYPE: {
        '01' : { key: 'frame.type.login',      name: '登录' },
        '02' : { key: 'frame.type.warning',    name: '告警' },
        '03' : { key: 'frame.type.escalation', name: '上报' },
        '04' : { key: 'frame.type.heartbeat',  name: '心跳' },

        '11' : { key: 'frame.type.login_success',   name: '登录成功' },
        '12' : { key: 'frame.type.receive_success', name: '接收成功' },
        '13' : { key: 'frame.type.get_data',        name: '获取数据' },
        '14' : { key: 'frame.type.remote_control',  name: '远程控制' },
    },
    // 定位状态
    GPS_STATUS: {
        '01': { key: 'frame.valid', name: '有效' },
        '00': { key: 'frame.invalid', name: '无效' },
    },
    // 温度传感器名称
    TEMPERATURE_SENSOR_NAME: [
        'Cell Temp 1',
        'Cell Temp 2',
        'Cell Temp 3',
        'PCB Temp 1',
        'DSG Mos Temp 1',
        'CHG Mos Temp 1',
        'Pre-Start Temp 1',
        'Pre-Charge Temp 1',
    ],

    BATTERY_STATUS: [
        // 内部状态 INTERNAL_STATE
        {
            '0': { key: 'frame.device_status.0_0', name: 'USB输出' },
            '1': { key: 'frame.device_status.0_1', name: '尾灯' },
            '2': { key: 'frame.device_status.0_2', name: '充电器识别状态' },
            '3': { key: 'frame.device_status.0_3', name: '充电器连接状态' },
            '4': { key: 'frame.device_status.0_4', name: '预充电路' },
            '5': { key: 'frame.device_status.0_5', name: '预放电路' },
            '6': { key: 'frame.device_status.0_6', name: '放电MOS' },
            '7': { key: 'frame.device_status.0_7', name: '充电MOS' },
        },{
            '7': { key: 'frame.device_status.1_0', name: '电池停止充电状态' },
        },
        // 错误 ERROR
        {
            '0': { key: 'frame.device_status.2_0', name: '保护 IC 出错' },
            '1': { key: 'frame.device_status.2_1', name: '电芯掉线' },
            '2': { key: 'frame.device_status.2_2', name: '电芯不平衡' },
            '3': { key: 'frame.device_status.2_3', name: '计量出错' },
            '4': { key: 'frame.device_status.2_4', name: '记录出错' },
            '5': { key: 'frame.device_status.2_5', name: '时钟出错' },
            '6': { key: 'frame.device_status.2_6', name: '放电 MOS 损坏' },
            '7': { key: 'frame.device_status.2_7', name: '充电 MOS 损坏' },
        },{
            '0': { key: 'frame.device_status.3_0', name: '过充错误' },
            '1': { key: 'frame.device_status.3_1', name: '初级过放' },
            '2': { key: 'frame.device_status.3_2', name: '二级过放错误' },
            '3': { key: 'frame.device_status.3_3', name: '初级过流' },
            '4': { key: 'frame.device_status.3_4', name: '二级过流' },
            '5': { key: 'frame.device_status.3_5', name: '充电过流' },
            '6': { key: 'frame.device_status.3_6', name: '软启动失败' },
            '7': { key: 'frame.device_status.3_7', name: '预充超时警告' },
        },{
            '0': { key: 'frame.device_status.4_0', name: 'MOS 温度传感器故障' },
            '1': { key: 'frame.device_status.4_1', name: '电芯温度传感器故障' },
            '2': { key: 'frame.device_status.4_2', name: '放电过温' },
            '3': { key: 'frame.device_status.4_3', name: '充电过温' },
            '4': { key: 'frame.device_status.4_4', name: '放电欠温' },
            '5': { key: 'frame.device_status.4_5', name: '充电欠温' },
            '6': { key: 'frame.device_status.4_6', name: '放电 MOS 过温' },
            '7': { key: 'frame.device_status.4_7', name: '充电 MOS 过温' },
        },{
            '0': { key: 'frame.device_status.5_0', name: '软启动电路过温' },
            '4': { key: 'frame.device_status.5_1', name: '三级过流' },
            '6': { key: 'frame.device_status.5_2', name: '配置错误' },
        },
        // 告警 ALARM
        {
            '0': { key: 'frame.device_status.6_0', name: '保护 IC 出错' },
            '1': { key: 'frame.device_status.6_1', name: '电芯掉线' },
            '2': { key: 'frame.device_status.6_2', name: '电芯不平衡' },
            '3': { key: 'frame.device_status.6_3', name: '计量出错' },
            '4': { key: 'frame.device_status.6_4', name: '记录出错' },
            '5': { key: 'frame.device_status.6_5', name: '时钟出错' },
            '6': { key: 'frame.device_status.6_6', name: '放电 MOS 损坏' },
            '7': { key: 'frame.device_status.6_7', name: '充电 MOS 损坏' },
        },{
            '0': { key: 'frame.device_status.7_0', name: '过充错误' },
            '1': { key: 'frame.device_status.7_1', name: '初级过放' },
            '2': { key: 'frame.device_status.7_2', name: '二级过放错误' },
            '3': { key: 'frame.device_status.7_3', name: '初级过流' },
            '4': { key: 'frame.device_status.7_4', name: '二级过流' },
            '5': { key: 'frame.device_status.7_5', name: '充电过流' },
            '6': { key: 'frame.device_status.7_6', name: '软启动失败' },
            '7': { key: 'frame.device_status.7_7', name: '预充超时警告' },
        }
    ],
    ERROR_MAP: {
        '0': { key: 'frame.device_status.2_0', name: '保护 IC 出错' },
        '1': { key: 'frame.device_status.2_1', name: '电芯掉线' },
        '2': { key: 'frame.device_status.2_2', name: '电芯不平衡' },
        '3': { key: 'frame.device_status.2_3', name: '计量出错' },
        '4': { key: 'frame.device_status.2_4', name: '记录出错' },
        '5': { key: 'frame.device_status.2_5', name: '时钟出错' },
        '6': { key: 'frame.device_status.2_6', name: '放电 MOS 损坏' },
        '7': { key: 'frame.device_status.2_7', name: '充电 MOS 损坏' },

        '8':  { key: 'frame.device_status.3_0', name: '过充错误' },
        '9':  { key: 'frame.device_status.3_1', name: '初级过放' },
        '10': { key: 'frame.device_status.3_2', name: '二级过放错误' },
        '11': { key: 'frame.device_status.3_3', name: '初级过流' },
        '12': { key: 'frame.device_status.3_4', name: '二级过流' },
        '13': { key: 'frame.device_status.3_5', name: '充电过流' },
        '14': { key: 'frame.device_status.3_6', name: '软启动失败' },
        '15': { key: 'frame.device_status.3_7', name: '预充超时警告' },

        '16': { key: 'frame.device_status.4_0', name: 'MOS 温度传感器故障' },
        '17': { key: 'frame.device_status.4_1', name: '电芯温度传感器故障' },
        '18': { key: 'frame.device_status.4_2', name: '放电过温' },
        '19': { key: 'frame.device_status.4_3', name: '充电过温' },
        '20': { key: 'frame.device_status.4_4', name: '放电欠温' },
        '21': { key: 'frame.device_status.4_5', name: '充电欠温' },
        '22': { key: 'frame.device_status.4_6', name: '放电 MOS 过温' },
        '23': { key: 'frame.device_status.4_7', name: '充电 MOS 过温' },

        '24': { key: 'frame.device_status.5_0', name: '软启动电路过温' },
        '25': { key: '', name: '' },
        '26': { key: '', name: '' },
        '27': { key: '', name: '' },
        '28': { key: 'frame.device_status.5_4', name: '三级过流' },
        '29': { key: '', name: '' },
        '30': { key: 'frame.device_status.5_6', name: '配置错误' },
        '31': { key: '', name: '' },
    }
}
const FILTER = {
    timeFilter: (val) => {
        return dayjs.unix(val).format('YYYY-MM-DD HH:mm:ss')
    },
    valueFilter: (val, map) => {
        let MAP = CONST[map] || {}
        let ITEM = MAP[padStart(val)]
        return ITEM ? [ITEM] : ''
    },
    countFilter: (val = 0 ,divisor = 100, dp = 2, type = false) => {
        if (val == 0) { return 0 }
        if (type) {
            return parseFloat((val * divisor).toFixed(dp))
        } else {
            return parseFloat((val / divisor).toFixed(dp))
        }
    },
    // BMS时间
    bmsTimeFilter: (v) => {
        return `20${padStart(v[0])}-${padStart(v[1])}-${padStart(v[2])} ${padStart(v[3])}:${padStart(v[4])}:${padStart(v[5])}`
    },
    // 温度传感器
    temperatureSensorFilter: (v) => {
        let arr = []
        for (let i = 0; i < CONST['TEMPERATURE_SENSOR_NAME'].length; i++) {
            arr.push({
                name: CONST['TEMPERATURE_SENSOR_NAME'][i],
                key: CONST['TEMPERATURE_SENSOR_NAME'][i],
                content: v[i],
            })
        }
        return arr;
    },
    // 电池版本
    versionFilter: (v) => {
        return [
            {
                name: '软件版本',
                key: 'device.software_version',
                content: `${v[0]}${v[1]}`,
            },{
                name: '硬件版本',
                key: 'device.hardware_version',
                content: `${v[2]}${v[3]}`,
            },{
                name: '固件索引码',
                key: 'device.firmware_index_code',
                content: `${v[4]}${v[5]}${v[6]}${v[7]}`,
            },
        ]
    },
    // 生产时间
    manufactureDateFilter: (v) => {
        return `20${padStart(v[0])}-${padStart(v[1])}-${padStart(v[2])}`
    },
    // 电芯电压
    cellVoltageFilter: (v) => {
        let arr = []
        for (let i = 0; i < v.length; i = i+2) {
            arr.push({ content: `${new DataView(v.slice(i, i+2).buffer).getUint16(0, true)}mV` })
        }
        // return arr;
        return arr.map(i => i.content).join(', ');
    },
    // 电池最值记录
    historyFilter: (v) => {
        return [
            {
                name: '最大放电电流',
                key: 'device.maximum_discharge_current',
                content: `${new DataView(v.slice(0,4).buffer).getInt32(0, true)}mAh`
            },{
                name: '最大充电电流',
                key: 'device.maximum_charging_current',
                content: `${new DataView(v.slice(4,8).buffer).getInt32(0, true)}mAh`
            },{
                name: '最大电芯电压',
                key: 'device.maximum_cell_voltage',
                content: `${new DataView(v.slice(8,10).buffer).getUint16(0, true)}mV`
            },{
                name: '最小电芯电压',
                key: 'device.minimum_cell_voltage',
                content: `${new DataView(v.slice(10,12).buffer).getUint16(0, true)}mV`
            },{
                name: '电池包最大温度',
                key: 'device.maximum_battery_pack_temperature',
                content:`${new DataView(v.slice(12,13).buffer).getInt8(0, true)}°`
            },{
                name: '电池包最小温度',
                key: 'device.minimum_battery_pack_temperature',
                content: `${new DataView(v.slice(13,14).buffer).getInt8(0, true)}°`
            },
        ]
    },

    // 错误计数
    errorCountFilter: (v) => {
        const ERROR_MAP = CONST.ERROR_MAP
        let arr = []

        for (let i = 0; i < v.length; i = i+2) {
            let d = ERROR_MAP[(i/2) + '']
            if (d.key) {
                arr.push({
                    ...d,
                    content: `${new DataView(v.slice(i, i+2).buffer).getUint16(0, true)}`,
                })
            }
        }

        return arr
    },
    // 电池状态
    batteryStatusFilter: (v) =>  {
        const BATTERY_STATUS = CONST.BATTERY_STATUS

        function getBit(b,i) { // 获取第i位的bit值 并判断
            let bit = (b >> i) & 0x1;
            return bit !== 0;
        }

        let parts = []
        for (let i = 0; i < BATTERY_STATUS.length; i++) {
            let _v = v[i]
            for (const key in BATTERY_STATUS[i]) {
                if (getBit(_v, parseInt(key))) {
                    parts.push({
                        ...BATTERY_STATUS[i][key],
                    })
                }
            }
        }
        parts.push({ key: 'frame.device_status.8',  name: '电池剩余容量百分比', content: `${v[8]}%` })
        parts.push({ key: 'frame.device_status.9',  name: '电池健康状态百分比', content: `${v[9]}%` })
        parts.push({ key: 'frame.device_status.10', name: '电池包总电压', content: `${new DataView(v.slice(10,14).buffer).getUint32(0, true)}mV` })
        parts.push({ key: 'frame.device_status.14', name: '实时电流', content: `${new DataView(v.slice(14,18).buffer).getUint32(0, true)}mA` })
        parts.push({ key: 'frame.device_status.18', name: '实时电芯最高温度', content: `${v[18]}°` })
        parts.push({ key: 'frame.device_status.19', name: '实时电芯最低温度', content: `${v[19]}°` })
        parts.push({ key: 'frame.device_status.20', name: '实时Mos管温度', content: `${v[20]}°` })
        parts.push({ key: 'frame.device_status.21', name: '其他温度', content: `${v[21]}°` })

        let maximum_charge_current_unit = (v[22] >> 6) & (0xFF >> 6)
        switch (maximum_charge_current_unit) {
            case 0: maximum_charge_current_unit = 0.05; break;
            case 1: maximum_charge_current_unit = 0.1; break;
            case 2: maximum_charge_current_unit = 1; break;
            case 3: maximum_charge_current_unit = 2; break;
        }
        let maximum_charge_current = (v[22] >> 0) & (0xFF >> 2)
        parts.push({ key: 'frame.device_status.22', name: '允许最大充电电流', content: `${maximum_charge_current * maximum_charge_current_unit}A` })

        // byte 23： 放电信息 Discharging message Bit7 ~ Bit0: Reserved
        parts.push({ key: 'frame.device_status.24', name: '电池循环次数', content: `${new DataView(v.slice(24,26).buffer).getUint16(0, true)}` })

        return parts
    }
}
const CMD_MAP = {
    0x01: { cmd: '0x01', type: 'uint8',  key: 'frame_type', name: '帧类型', filter: 'valueFilter', params: ['FRAME_TYPE'] },
    0x02: { cmd: '0x02', type: 'number', key: 'timestamp', name: '时间戳', filter: 'timeFilter' },
    0x03: { cmd: '0x03', type: 'hex',    key: 'packet_id', name: '包流水号' },
    0x04: { cmd: '0x04', type: 'bytes',  key: 'bms_time', name: 'BMS时间', filter: 'bmsTimeFilter' },

    0x12: { cmd: '0x12', type: 'string', key: 'bms_id', name: 'BMS ID' },
    0x14: { cmd: '0x14', type: 'uint8',  key: 'gsm_signal_strength', name: 'GSM信号强度', filter: 'countFilter', params: [0.31, 2, true] },
    0x15: { cmd: '0x15', type: 'uint8',  key: 'gps_signal_strength', name: 'GPS信号强度', filter: 'countFilter', params: [0.45, 2, true] },
    0x16: { cmd: '0x16', type: 'uint8',  key: 'gps_satellite_in_view_count', name: 'GPS可见卫星数量' },
    0x17: { cmd: '0x17', type: 'uint8',  key: 'gnss_satellite_used_count', name: 'GNSS卫星数量' },
    0x21: { cmd: '0x21', type: 'uint8',  key: 'gps_state', name: '定位状态', filter: 'valueFilter', params: ['GPS_STATUS'] },
    0x25: { cmd: '0x25', type: 'uint32', key: 'longitude',name: '经度', filter: 'countFilter', params: [1000000, 6] },
    0x26: { cmd: '0x26', type: 'uint32', key: 'latitude', name: '纬度', filter: 'countFilter', params: [1000000, 6] },
    0x27: { cmd: '0x27', type: 'uint16', key: 'speed', name: '定位速度', filter: 'countFilter', params: [100, 2], unit: 'KM/H' },
    0x28: { cmd: '0x28', type: 'uint16', key: 'location_angle', name: '定位角度', filter: 'countFilter', params: [100, 2] },

    0x41: { cmd: '0x41', type: 'uint32', key: 'voltage', name: '电压' },
    0x42: { cmd: '0x42', type: 'int32',  key: 'current', name: '电流' },
    0x43: { cmd: '0x43', type: 'uint8', key: 'soc', name: 'SOC' },
    0x44: { cmd: '0x44', type: 'bytes', key: 'temperature_sensor', name: '温度传感器', filter: 'temperatureSensorFilter' },
    0x45: { cmd: '0x45', type: 'uint32', key: 'remaining_capacity', name: '剩余容量', unit: 'mAh' },
    0x46: { cmd: '0x46', type: 'uint32', key: 'full_charge_capacity', name: '充满容量', unit: 'mAh' },
    0x47: { cmd: '0x47', type: 'uint32', key: 'cycle_count', name: '循环次数' },
    0x48: { cmd: '0x48', type: 'uint32', key: 'rated_capacity', name: '额定容量', unit: 'mAh' },
    0x49: { cmd: '0x49', type: 'uint32', key: 'rated_voltage', name: '额定电压', unit: 'mV' },
    0x50: { cmd: '0x50', type: 'bytes',  key: 'version', name: '版本', filter: 'versionFilter' },
    0x51: { cmd: '0x51', type: 'bytes',  key: 'manufacture_date', name: '生产时间', filter: 'manufactureDateFilter' },
    0x53: { cmd: '0x53', type: 'string', key: 'manufacture_name', name: '制造商' },
    0x54: { cmd: '0x54', type: 'string', key: 'name', name: '名称' },
    0x55: { cmd: '0x55', type: 'string', key: 'chem_id', name: '电芯型号' },
    0x56: { cmd: '0x56', type: 'string', key: 'bms_bar_code', name: 'BMS条码' },

    0x57: { cmd: '0x57', type: 'bytes', key: 'cell_voltage_1', name: '电芯电压 1', filter: 'cellVoltageFilter' },
    0x58: { cmd: '0x58', type: 'bytes', key: 'cell_voltage_2', name: '电芯电压 2', filter: 'cellVoltageFilter' },
    0x59: { cmd: '0x59', type: 'bytes', key: 'history', name: '电池最值记录', filter: 'historyFilter' },

    0x60: { cmd: '0x60', type: 'bytes',  key: 'system_error_status', name: '错误计数', filter: 'errorCountFilter' },
    0x67: { cmd: '0x67', type: 'bytes',  key: 'battery_status', name: '电池状态', filter: 'batteryStatusFilter' },
    0x71: { cmd: '0x71', type: 'uint16', key: 'iot_temperature', name: 'DTU模块温度' },
    0x72: { cmd: '0x72', type: 'uint32', key: 'gprs_total_data_used', name: 'GPRS数据使用量' },
    0x73: { cmd: '0x73', type: 'string', key: 'dtu_software_version', name: 'DTU版本' },
    0x74: { cmd: '0x74', type: 'string', key: 'bms_software_version', name: 'BMS版本' },
    0x75: { cmd: '0x75', type: 'hex',    key: 'bluetooth_mac', name: '蓝牙MAC' },

    0xE1: { cmd: '0xE1', type: 'string', key: 'iccid', name: 'ICCID' },
    0xE2: { cmd: '0xE2', type: 'string', key: 'imei', name: 'IMEI' },
    0xE3: { cmd: '0xE3', type: 'string', key: 'gprs_apn', name: 'GPRS APN' },
    0xE4: { cmd: '0xE4', type: 'string', key: 'bluetooth_password', name: '蓝牙连接密码' },
}
// BKV 翻译
export function publishFrame(hex) {
    let res = runParser(hex)
    if (res.code !== 0) { return res }

    let frame = res.data
    let data = {}

    // console.log('publishFrame frame:', frame)

    try {
        let items = frame.items()
        for (let index = 0; index < items.length; index++) {
            let item = items[index];
            let k = item.key();
            let v = item.value();

            let d = CMD_MAP[k] || {cmd : '0x' + (k.toString(16))}

            let content = ''

            try {
                switch (d.type) {
                    case 'string':
                        content = item.stringValue()
                        break;
                    case 'uint8':
                        content = new DataView(v.buffer).getUint8(0, true)
                        break;
                    case 'int8':
                        content = new DataView(v.buffer).getInt8(0, true)
                        break;
                    case 'uint16':
                        content = new DataView(v.buffer).getUint16(0, true)
                        break;
                    case 'int16':
                        content = new DataView(v.buffer).getInt16(0, true)
                        break;
                    case 'uint32':
                        content = new DataView(v.buffer).getUint32(0, true)
                        break;
                    case 'int32':
                        content = new DataView(v.buffer).getInt32(0, true)
                        break;
                    case 'number':
                        content = parseInt(arrayBufferToHex(v), 16)
                        break;
                    case 'hex':
                        content = arrayBufferToHex(v)
                        break;
                    case 'bytes':
                        content = v
                        break;
                    case 'data':
                        content = bkvUnpack(arrayBufferToHex(v), true)
                        break;
                }
                if (d.filter) {
                    content = FILTER[d.filter](content, ...(d.params ? d.params : []))
                }
            } catch (error) {
                console.log('publishFrame d:', d, 'value', arrayBufferToHex(v), 'error', error)
            }

            data[k] = {
                cmd: d.cmd || '',
                key: d.key ? 'device.'+d.key : '',
                unit: d.unit || '',
                name: d.name || '',
                type: d.type || '',
                value: arrayBufferToHex(v),
                content,
            }
            // console.log('publishFrame [',k,'] value:', v)
            // console.log('publishFrame [',k,'] data:',{...data[k], v})
        }
    } catch (error) {
        console.log('publishFrame error', error);
    }
    // console.log('publishFrame data:', data)
    return { code: 0, data, type: res.type }
}